<template>
  <div class="mess_box">
    <vab-collapse :title="title" class="message_collapse">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="me_item flex_start"
      >
        <span class="time">{{ item.adjScheduleStatusDatetime }}</span>
        <div class="me_inner flex_colum">
          <div class="flex_start flex_center_align">
            <img src="~@/assets/images/r9.png" alt="" />
            <span class="word">
              {{ getMessageCompanyName(item) }}
            </span>
          </div>
          <div class="state_box flex_colum">
            <div
              v-if="item.adjScheduleStatus || item.docSubmitStatus"
              class="flex_start"
            >
              <div
                v-if="
                  isEqualCodeEnum(
                    item.adjScheduleStatus
                      ? item.adjScheduleStatus
                      : item.docSubmitStatus,
                    $divisions.adjScheduleStatusEnum.enum_5
                  )
                "
                class="img_box2"
              >
                <img class="common_img" src="~@/assets/images/r11.png" alt="" />
              </div>
              <div v-else class="img_box">
                <img class="common_img" src="~@/assets/images/r10.png" alt="" />
              </div>
              <span class="state_word">
                <div
                  :class="{
                    error: isEqualCodeEnum(
                      item.adjScheduleStatus
                        ? item.adjScheduleStatus
                        : item.docSubmitStatus,
                      $divisions.adjScheduleStatusEnum.enum_5
                    ),
                  }"
                >
                  {{
                    item.adjScheduleStatus
                      ? getEnumText(
                          item.adjScheduleStatus,
                          $divisions.adjScheduleStatusEnum
                        )
                      : getEnumText(
                          item.docSubmitStatus,
                          $divisions.docSubmitStatusEnum
                        )
                  }}
                </div>
              </span>
            </div>
            <div
              v-if="item.submitRemarks || item.confirmRemarks"
              class="tichu pre_wrap"
            >
              {{ item.submitRemarks || item.confirmRemarks }}
            </div>
          </div>
        </div>
      </div>
    </vab-collapse>
  </div>
</template>

<script>
  import { getScheduleAdjHistory } from '@/api/scheduleAdjHistory'
  export default {
    name: 'VabMessage',
    props: {
      msgId: {
        type: [String, Number],
        default: '',
      },
      title: {
        type: [String, Number],
        default: '',
      },
      msgType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        list: [],
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getMessageCompanyName(item) {
        // 協力会社
        if (
          this.isEqualCodeEnum(
            this.msgType,
            this.$divisions.adjSourceClassEnum.enum_1
          )
        ) {
          return this.getEnumText(
            this.getFieldValue('adjSourceClass', item),
            this.$divisions.adjSourceClassEnum
          )
        } else {
          // DLN
          if (
            this.isEqualCodeEnum(
              this.getFieldValue('adjSourceClass', item),
              this.$divisions.adjSourceClassEnum.enum_1
            )
          ) {
            return this.getEnumText(
              this.getFieldValue('adjSourceClass', item),
              this.$divisions.adjSourceClassEnum
            )
          } else {
            return (
              this.getFieldValue(
                'requestDetailIdModel.requestDestCdModel.bcnfrkj',
                item
              ) || this.getFieldValue('userName', item)
            )
          }
        }
      },
      async getList() {
        if (!this.msgId) {
          return
        }
        let res = await getScheduleAdjHistory(this.msgId)
        this.list = res ?? []
      },
      setList(commentList) {
        this.list = commentList
      },
    },
  }
</script>

<style lang="scss" scoped></style>
